
import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import AreaHero from '../components/AreaHero';
import AreaServices from '../components/AreaServices';
import AreaTestimonials from '../components/AreaTestimonials';
import AreaCTA from '../components/AreaCTA';
import { useSEO, generateAreaPageSchema, generateBreadcrumbSchema } from '../../../utils/seo';

export default function RadlettPage() {
  const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'Painters & Decorators Radlett Hertfordshire | Brushour',
    description: 'Quality painting and decorating services in Radlett, Hertfordshire. Covering Radlett Village, Aldenham, and Letchmore Heath. Fully insured, 18+ years experience. Free quotes available.',
    keywords: 'painters Radlett, decorators Radlett Hertfordshire, painting services Radlett, Radlett painters decorators, decorating Aldenham',
    canonical: `${SITE_URL}/areas/radlett`,
    schema: [
      generateAreaPageSchema('Radlett', 'Hertfordshire', 'radlett', 51.6833, -0.3167, 'WD7'),
      generateBreadcrumbSchema([
        { name: 'Home', url: SITE_URL },
        { name: 'Areas', url: `${SITE_URL}/areas` },
        { name: 'Radlett', url: `${SITE_URL}/areas/radlett` },
      ]),
    ],
  });

  const areaData = {
    name: 'Radlett',
    region: 'Hertfordshire',
    description: 'Quality painting and decorating services in Radlett. Our skilled painters and decorators bring years of experience to every project, ensuring exceptional results for homes and businesses throughout Radlett and nearby communities.',
    heroImage: 'https://public.readdy.ai/ai/img_res/b36e916aceb356035c5c89e684f801e0.jpg',
    serviceAreas: ['Radlett Village', 'Aldenham', 'Letchmore Heath', 'Round Bush'],
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <AreaHero data={areaData} />
      <AreaServices area="Radlett" />
      <AreaTestimonials area="Radlett" />
      <AreaCTA area="Radlett" />
      <Footer />
    </div>
  );
}
